import MYOBSync from './MYOBSync';

export default MYOBSync;
